// ── Zwolle-referentie (KNMI Heino 1991-2020) ──────────────────
// Single source of truth voor de "vergeleken met thuis"-vergelijking.
export const ZWOLLE = {
  label:              "Zwolle",
  annual_rainfall_mm: 827,
  annual_sunshine_h:  1676,
};

// Positief = droger dan Zwolle. Bv. 620 mm -> +25%.
export function rainfallDeltaPct(mm) {
  if (mm == null || isNaN(mm)) return null;
  return Math.round((1 - mm / ZWOLLE.annual_rainfall_mm) * 100);
}

// Positief = meer zon dan Zwolle. Bv. 2900 h -> +73%.
export function sunshineDeltaPct(h) {
  if (h == null || isNaN(h)) return null;
  return Math.round((h / ZWOLLE.annual_sunshine_h - 1) * 100);
}
